import React from 'react';
import LeftRightSelect from '../../../../components/left-right-select/LeftRightSelect';

export default (props) => {
    const {
        key,
        value,
        forcedValue,
        data,
        rules,
        options,
        disabled,
        ruleRequired,
        isRequired,
        onChange
    } = props;

    return <LeftRightSelect
        items={data.items}
        defaultSelectedItems={value.length > 0 ? value : data.defaultSelectedItems}
        renderItemContent={data.renderItemContent}
        getItemIsDisabled={data.getItemIsDisabled}
        isItemsLoading={data.isItemsLoading}
        itemsLoadingError={data.itemsLoadingError}
        updateSearch={data.updateSearch}
        searchQuery={data.searchQuery}
        onLeftItemsViewScrollBottom={data.onLeftItemsViewScrollBottom}
        updateSelectedItems={onChange}
        disabled={disabled}
        sortable={options.sortable}
    />;
}
